import React from "react";
import { withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { withFocusable } from "../../services/visualLibraryService";
import {
  PromotionPageStyled,
  PromotionContainerStyled,
  ButtonModalStyled,
  LogoStyled,
  TextStyled,
  SecondaryLogoStyled,
  LogoContainerStyled
} from "./styles/Styled";
import { i18n } from "../../services/i18nService";
import { historyMethods } from "../../utils/historyMethods";
import { redirectTo } from "../../services/navigationService";
import { routes } from "../../routes";
import { getSdk } from "../../services/sdkService";
import Logo from "../../components/Logo";
import FreeLogo from "../../components/FreeLogo";

const OPENAPPID = "3201807016658"; // Samsung promotion app id
const ButtonModalFocus = withFocusable(ButtonModalStyled);
const openPromotionAppPath = "openPromotionApp_passThru";
const dismissPromotionPath = "dismissPromotion_passThru";

class PromotionPage extends React.Component {
  constructor(props) {
    super(props);
    this.onBack = this.onBack.bind(this);
    this.openAppHandler = this.openAppHandler.bind(this);
    this.dismissHandler = this.dismissHandler.bind(this);
  }

  componentDidMount() {
    const {
      onRef,
      applicationState,
      stateActions: { getHomePath, setShowPromotionPageValue }
    } = this.props;

    if (applicationState.showPromotionPage) {
      setShowPromotionPageValue(false);
    } else {
      redirectTo.call(this, getHomePath(), null, historyMethods.REPLACE);
      return;
    }
    onRef && onRef(this);
  }

  dismissHandler() {
    // trackEvent(SIGNUP, eventAction);
    redirectTo.call(this, routes.home, null, historyMethods.REPLACE);
  }

  async openAppHandler() {
    // trackEvent(SIGNUP, eventAction);
    const sdk = await getSdk();
    sdk.systemManager.application.openDeepLinkApp && sdk.systemManager.application.openDeepLinkApp(OPENAPPID);
  }

  onBack() {
    redirectTo.call(this, routes.home, null, historyMethods.REPLACE);
    return true;
  }

  render() {
    const { userLocale } = this.props.applicationState;
    return (
      <PromotionPageStyled
        background={`http://mena-cdn-lb.aws.playco.com/prd-peg-data/default/html5/resources/images/welcome/default/BG-Image-EN.png`}
      >
        {/* {this.state.isLoading && <Loading overlay />} */}
        <PromotionContainerStyled>
          <LogoContainerStyled>
            <SecondaryLogoStyled
              src="http://mena-cdn-lb.aws.playco.com/prd-peg-data/default/bigscreen/images/tizen/samsung-promotion/logo-samsung-promotion.png"
              width="150"
              alt="SAMSUNG PROMOTION"
              inlineBlock
            />
            <LogoStyled>
              <FreeLogo />
            </LogoStyled>
          </LogoContainerStyled>
          <TextStyled rank="1" text={i18n.get("pages.promotion.heading")} size="medium" />
          <TextStyled rank="3" text={i18n.get("pages.promotion.subHeading1")} size="medium" bold />
          <TextStyled rank="3" text={i18n.get("pages.promotion.subHeading2")} size="medium" />

          <ButtonModalFocus
            label={i18n.get("pages.promotion.openAppButton")}
            focusPath={openPromotionAppPath}
            onEnterPress={() => this.openAppHandler()}
            size="medium"
            dataSnUp={""}
            dataSnDown={`@${dismissPromotionPath}`}
            dataSnLeft={""}
            dataSnRight={""}
            userLocale={userLocale}
          />

          <ButtonModalFocus
            label={i18n.get("pages.promotion.dismissButton")}
            focusPath={dismissPromotionPath}
            onEnterPress={() => this.dismissHandler()}
            size="medium"
            dataSnUp={`@${openPromotionAppPath}`}
            dataSnDown={""}
            dataSnLeft={""}
            dataSnRight={""}
            userLocale={userLocale}
          />
        </PromotionContainerStyled>
      </PromotionPageStyled>
    );
  }
}

export default withAppState(withSubtheme(PromotionPage));
